import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Richtext/styles.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/atoms/Title/styles.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/components/organisms/Wrapper/styles.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4135544797/src/bitbucket.org/grupoblidoo/passport-frontend/src/app/[lang]/(public)/(layout-without-headertitle)/about-us/styles.scss");
